import * as React from 'react';
import { Box } from '@mui/material';
import './LeaveStatusCard.css';
import { Typography } from '@mui/material';
import '../../App.css';
import { getUserData } from '../../services/UserService';
import { useEffect } from 'react';
import { useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import moment from 'moment';

export default function LeavesStatus(props) {
  const { managerResponse } = props;
  const [manager, setManager] = useState({});
  const getManager = async () => {
    const userDetails = await getUserData(managerResponse.approverId);
    if (userDetails.isError === false) {
      setManager(userDetails.data);
    }
  };

  useEffect(() => {
    getManager();
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <div className="space-between-container mb-2">
        <Typography
          sx={{ width: '25%', textTransform: 'capitalize' }}
          // variant="h7"
        >
          {manager.firstName 
            ? `${manager.firstName} ${manager.lastName || ''}`
            : (managerResponse.approverId && managerResponse.approverId.includes('@'))
              ? managerResponse.approverId.split('@')[0].replace('.', ' ')
              : 'HR/Admin'}
        </Typography>
        <Typography
          sx={{ width: '45%', display: 'flex', justifyContent: 'left' }}
          // variant="h7"
        >
          {managerResponse.comments || 'No Comments'}
        </Typography>
        <Typography
          sx={{ width: '15%', display: 'flex', justifyContent: 'right' }}
          // variant="h7"
        >
          {managerResponse.dateOfResponse
            ? moment(managerResponse.dateOfResponse).format('DD MMM YYYY')
            : 'Not Replied Yet'}
        </Typography>
        <Box sx={{ width: '15%', display: 'flex', justifyContent: 'center' }}>
          {managerResponse.status === 'APPROVED' ? (
            <CheckCircleOutlineIcon color="success" />
          ) : managerResponse.status === 'REJECTED' ? (
            <CancelOutlinedIcon color="error" />
          ) : (
            <HourglassTopOutlinedIcon color="warning" />
          )}
        </Box>
      </div>
    </Box>
  );
}
